export const SystemUserStatusCssClasses = { true: "success", false: "danger" };
export const SystemUserStatusTitles = { true: "Aktif", false: "Pasif" };
export const SystemUserConfirmationTitles = { true: "Evet", false: "Hayır" };
export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "25", value: 25 },
  { text: "50", value: 50 },
  { text: "100", value: 100 }
];
export const SystemUserConfirmationOptions = [
  { value: null, label: "Tümü" },
  { value: true, label: "Evet" },
  { value: false, label: "Hayır" }
];
export const SystemUserStatusOptions = [
  { value: null, label: "Tümü" },
  { value: true, label: "Aktif" },
  { value: false, label: "Pasif" }
];
export const initialFilter = {
  filter: {
    name: "",
    surname: "",
    username: "",
    isSuperAdmin: null,
    isActive: null    
  },
  sortOrder: "asc", // asc||desc
  sortField: "name",
  pageNumber: 1,
  pageSize: 10
};